import React from 'react';
import { SliderInput } from '@meitu/saas-ui';

interface IProps {
    title: string;
    size: number;
    onClick: (val: number) => void;
}
const BorderSize: React.FC<IProps> = (props) => {
    const { title, size, onClick } = props;

    return (
        <div className="design-svg-operate__border">
            <div className="design-svg-title">{title}:</div>
            <SliderInput
                type="horizontal"
                min={0}
                max={500}
                value={size}
                onChange={(newValue: number) => {
                    onClick?.(newValue);
                }}
                tooltipVisible={false}
            ></SliderInput>
        </div>
    );
};
export default React.memo(BorderSize);
